module.exports = __webpack_public_path__ + "media/images/menu/m7-f99ee539e760749c0b71db1d094df630.JPG";